var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider display-22-20 pa-0 pr-3"},[_vm._v(_vm._s(_vm.highlight))])}
var staticRenderFns = []

export { render, staticRenderFns }